import { MFATrustedDevice } from '@organization/models'
import { ConditionalText, DateTimeCell } from '@shared/components'
import { ColumnProps } from 'antd/es/table'
import { TFunction } from 'i18next'

import { DeleteTrustedDevice } from './DeleteTrustedDevice'

export const getTrustedDevicesTableColumns = (
  t: TFunction
): ColumnProps<MFATrustedDevice>[] => [
  {
    title: t('device_name'),
    key: 'device_name',
    dataIndex: 'device_name',
    render: (value) => (
      <ConditionalText
        condition={!!value}
        ellipsis={{ tooltip: value }}
        style={{ maxWidth: 250 }}
      >
        {value}
      </ConditionalText>
    ),
    width: 250
  },
  {
    title: t('ip'),
    key: 'ip_address',
    dataIndex: 'ip_address',
    render: (value) => (
      <ConditionalText condition={!!value}>{value}</ConditionalText>
    )
  },
  {
    title: t('created_at'),
    key: 'created_at',
    dataIndex: 'created_at',
    render: (date) => <DateTimeCell date={date} />
  },
  {
    title: t('last_used'),
    key: 'last_used',
    dataIndex: 'last_used',
    render: (date) => <DateTimeCell date={date} />
  },
  {
    title: t('expires_at'),
    key: 'expires_at',
    dataIndex: 'expires_at',
    render: (date) => <DateTimeCell date={date} />
  },
  {
    key: 'actions',
    render: (_, record) => <DeleteTrustedDevice data={record} />
  }
]
